import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Announcements.module.scss';
import Button from 'components/shared/button/Button';
import SentTab from './SentTab/SentTab';
import ScheduledTab from './ScheduledTab/ScheduledTab';
import { Tab, Tabs } from '@mui/material';
import { permissionsDenied } from 'utils/permission';
import { getUserAccess } from 'utils/utils';


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


const Announcements = () => {

  const navigate = useNavigate()
  const location = useLocation();
  const { type } = location.state || {};
  const [value, setValue] = useState(type === "scheduled" ? 1 : 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const renderActiveTab = () => {
    switch (value) {
      case 0:
        return <SentTab />;
      case 1:
        return <ScheduledTab />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (location.state) {
      navigate('/announcements', { replace: true });
    }
  }, [navigate, location.state]);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={`${styles.tabMenu}`}>
          <div className={styles.tabs}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="SENT" {...a11yProps(0)} />
             { !permissionsDenied[getUserAccess()]?.includes("ScheduledAnnouncement") && <Tab label="SCHEDULED" {...a11yProps(1)} />}
            </Tabs>
          </div>
          {
            !permissionsDenied[getUserAccess()]?.includes("createAnnouncements") &&
            <Button
              className={styles.createAnnouncement}
              onClick={() => {
                navigate("/announcements/create")
              }}
              label="Create"
            >
              <span style={{ fontSize: "15px" }}>Create Announcement</span>
            </Button>
          }

        </div>
        {renderActiveTab()}
      </div>
    </>
  )
}

export default Announcements